import React from "react";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { Image, Col, Form, Button, Row } from "react-bootstrap";
import {
  TextField,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
} from "@material-ui/core";
//import Paper from "@material-ui/core/Paper";
//import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
//import SearchIcon from "@material-ui/icons/Search";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";

export const SuperAdminTopTextSearchIcon = (props) => {
  return (
    <React.Fragment>
      <div className="row super-admin-toptext-searchbar-icon">
        <div className="col-6">
          <div className="col-9 p-0">
            {props.userManagement ? (
              <Form.Control
                type="text"
                placeholder="Search by user name, user id, location"
                onChange={props.onChange}
                value={props.search}
                className="amSearch"
              />
            ) : (
              <Form.Control
                type="text"
                placeholder="Search by name"
                onChange={props.onChange}
                value={props.search}
                className="amSearch"
              />
            )}
          </div>
        </div>

        <div className="col-6">
          <div className="d-flex justify-content-end align-items-center">
            <div className="text-blue f15-500 mr-3">Sort by</div>
            {props.userManagement ? (
              <>
                <FormControl variant="filled" className="enSortSelect">
                  <Select
                    value={props.sortBy}
                    onChange={props.sortByChangeCode}
                    inputProps={{
                      name: "SortBy",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    {sortBy.map((data) => {
                      return (
                        <MenuItem
                          value={data.title}
                          defaultValue={props.SortBy}
                          key={data.id}
                        >
                          {data.title}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </>
            ) : (
              <>
                <FormControl variant="filled" className="enSortSelect">
                  <Select
                    value={props.sortBy}
                    onChange={(e) => props.handleChangeCode(e.target.value)}
                    inputProps={{
                      name: "SortBy",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    <MenuItem value="namea-z">Name A-Z</MenuItem>
                    <MenuItem value="namez-a">Name Z-A</MenuItem>
                  </Select>
                </FormControl>
              </>
            )}

            <div className="text-blue f15-500 ml-5 mr-3">Filters</div>
            <IconButton className="enDownIcon" onClick={props.handleShowFilter}>
              <Image
                src={require("../../../../assets/images/UserManagement/chevron-down.svg")}
                alt="View"
                title="View"
              />
            </IconButton>
          </div>
        </div>
        {props.showFilter && (
          <div className="col-12  mt-3">
            <div className="enWhiteBox mt-3">
              <Form className="row justify-content-between">
                {props.userManagement && (
                  <Col md={5}>
                    Date Range
                    <div
                      className="d-flex justify-content-start"
                      style={{ alignItems: "center" }}
                    >
                      <TextField
                        type="date"
                        variant="outlined"
                        onChange={props.onStartDateChange}
                        value={props.startDate}
                      />
                      &nbsp;To&nbsp;
                      <TextField
                        type="date"
                        variant="outlined"
                        onChange={props.onEndDateChange}
                        value={props.endDate}
                      />
                    </div>
                    <br />
                  </Col>
                )}
                <Col md={5}>
                  {props.userManagement && <br />}
                  <Form.Group>
                    <TextField
                      variant="outlined"
                      label="User ID"
                      className="w-100"
                      value={props.searchByUserId}
                      onChange={(e) =>
                        props.onChangeUserIdSearch(e.target.value)
                      }
                    />
                  </Form.Group>
                </Col>
                {props.userManagement ? (
                  <Col md={6}>
                    <Row>
                      <Col xs={3} className="pr-0">
                        <FormControl variant="outlined" className="w-100">
                          <Select
                            value={props.state.code}
                            onChange={props.handleChangeCode}
                            inputProps={{
                              name: "code",
                            }}
                          >
                            <MenuItem value={props.state.country_code}>
                              {props.state.country_code}
                            </MenuItem>
                            {getCountries().map((country) => (
                              <MenuItem
                                key={country}
                                value={"+" + getCountryCallingCode(country)}
                              >
                                {en[country]} (+
                                {getCountryCallingCode(country)})
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Col>
                      <Col xs={7}>
                        <Form.Group>
                          <NewInputText
                            extraClass="mb-0"
                            name="number"
                            inputType="number"
                            maxLength="10"
                            labelText="Phone Number"
                            onChange={(e) =>
                              props.onChangeMobileNumber(e.target.value)
                            }
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                ) : (
                  <Col md={5}>
                    <Row>
                      <div className="col-3 pr-0">
                        <Form.Group
                          className="reusableInputComponent-main mb-0"
                          controlId={"country_code"}
                        >
                          <div className="input-phone-country-code-reusable w-100">
                            <select
                              className="w-100"
                              name="country_code"
                              value={"+91"}
                              // onChange={this.onChange}
                            >
                              <MenuItem value={"+91"}>+91</MenuItem>
                            </select>
                          </div>
                        </Form.Group>
                      </div>
                      <div className="col-9">
                        <NewInputText
                          extraClass="mb-0"
                          name="number"
                          inputType="number"
                          maxLength="10"
                          labelText="Phone Number"
                        />
                      </div>
                    </Row>
                    {/* <Form.Group> */}
                    {/* <TextField
                  variant="outlined"
                  label="Phone Number"
                  className="w-100"
                  value={props.phoneNumberSearch}
                  onChange={(e) =>
                    props.onChangeMobileNumber(e.target.value)
                  }
                  //onChange={props.}
                /> */}
                    {/* </Form.Group> */}
                  </Col>
                )}

                <Col md={5}>
                  <Form.Group>
                    {/* <FormControl variant="outlined" className="w-100">
                      <InputLabel htmlFor="outlined-Location">
                        Location
                      </InputLabel>
                      <Select
                        value={props.Location}
                        onChange={props.handleChangeCode}
                        label="Location"
                        inputProps={{
                          name: "Location",
                          id: "outlined-Location",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        <MenuItem value="pune">Pune</MenuItem>
                      </Select>
                    </FormControl> */}
                    <TextField
                      variant="outlined"
                      label="Location"
                      className="w-100"
                      value={props.location}
                      onChange={(e) => props.onChangeLocation(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={5}>
                  <Form.Group>
                    <FormControl variant="outlined" className="w-100">
                      <InputLabel htmlFor="outlined-Status">Profile</InputLabel>
                      <Select
                        value={props.profile}
                        onChange={props.profileChangeCode}
                        label="Status"
                        inputProps={{
                          name: "Status",
                          id: "outlined-Status",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {profileCompletion.map((data) => {
                          return (
                            <MenuItem value={data.title} key={data.id}>
                              {data.title}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <div className="d-flex align-items-center">
                    <Button
                      variant="outline-secondary"
                      className="btn-lg mr-4 px-5"
                      onClick={props.handleShowFilter}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="danger"
                      className="btn-lg px-5"
                      onClick={props.handleSaveButton}
                    >
                      Search
                    </Button>
                  </div>
                </Col>
              </Form>
            </div>
          </div>
        )}
      </div>
      {/* <div className="col-12 super-admin-toptext-searchbar-icon">
        <div className="col-6 p-0">
          <h3>{topText}</h3>
        </div>
        <div className="col-6 p-0 d-flex align-items-center justify-content-end">
          <div className="col-6 p-0">
            <InputBoxComponent
              displayLabel={false}
              controlId="search"
              inputType="search"
              placeHolder="Search"
              name="phoneNumber"
              onChange={onChange}
              value={search}
              inputClassName="input-component-inputfield"
            />
          </div>
          {/* {displayIcon === true ? (
            <div className="super-admin-filter-button">{filter}</div>
          ) : null} *
        </div>
      </div> */}
    </React.Fragment>
  );
};

export const SuperAdminFilter = (props) => {
  return (
    <React.Fragment>
      <div
        className={`row super-admin-toptext-searchbar-icon ${props?.extraClass}`}
      >
        {!props.hide && (
          <>
            <div className="col-6">
              <div className="col-9 p-0">
                <Form.Control
                  type="text"
                  placeholder="Search by offer name and coupon code"
                  onChange={props.onChange}
                  value={props.search}
                  className="amSearch"
                />
              </div>
            </div>
            <div className="col-6">
              <div className="d-flex justify-content-end align-items-center">
                <div className="text-blue f15-500 mr-3">Sort by</div>
                <FormControl variant="filled" className="enSortSelect">
                  <Select
                    value={props.sortBy}
                    onChange={props.handleChangeCode}
                    inputProps={{
                      name: "SortBy",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    {sortByCode.map((data) => {
                      return (
                        <MenuItem value={data.title} key={data.id}>
                          {data.title}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                <div className="text-blue f15-500 ml-5 mr-3">Filters</div>
                <IconButton
                  className="enDownIcon"
                  onClick={props.handleShowFilter}
                >
                  <Image
                    src={require("../../../../assets/images/UserManagement/chevron-down.svg")}
                    alt="View"
                    title="View"
                  />
                </IconButton>
              </div>
            </div>
          </>
        )}
        {props.showFilter && (
          <div className="col-12  mt-3">
            <div className="enWhiteBox mt-3">
              <Form className="row justify-content-between">
                <Col md={5}>
                  <Form.Group>
                    <FormControl variant="outlined" className="w-100">
                      <InputLabel htmlFor="outlined-Status">Status</InputLabel>
                      <Select
                        value={props.status}
                        onChange={props.handleStatusChange}
                        label="Status"
                        inputProps={{
                          name: "Status",
                          id: "outlined-Status",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {statusCode.map((data) => {
                          return (
                            <MenuItem value={data.title} key={data.id}>
                              {data.title}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Form.Group>
                </Col>
                <Col md={5}>
                  <Form.Group>
                    <FormControl variant="outlined" className="w-100">
                      <InputLabel htmlFor="outlined-Offer">Offer</InputLabel>
                      <Select
                        value={props.offerType}
                        onChange={props.handleOfferTypeChange}
                        label="Offer"
                        inputProps={{
                          name: "Offer",
                          id: "outlined-Location",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {offerTypes.map((data) => {
                          return (
                            <MenuItem value={data.title} key={data.id}>
                              {data.title}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Form.Group>
                </Col>
                <Col>
                  <div className="d-flex align-items-center">
                    <Button
                      variant="outline-secondary"
                      className="btn-lg mr-4 px-5"
                      onClick={props.cancelClick}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="danger"
                      className="btn-lg px-5"
                      onClick={props.searchClick}
                    >
                      Search
                    </Button>
                  </div>
                </Col>
              </Form>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export const SuperAdminTopSearchIcon = ({
  onChange,
  search,
  filter,
  displayIcon,
}) => {
  return (
    <React.Fragment>
      <div className="col-12 super-admin-toptext-searchbar-icon">
        <div className="col-12 p-0 d-flex align-items-center justify-content-end">
          <div className="col-12 p-0">
            <NewInputText
              displayLabel={false}
              controlId="search"
              inputType="search"
              placeholder="Search"
              inputLabel="Search"
              name="phoneNumber"
              onChange={onChange}
              value={search}
              inputClassName="input-component-inputfield"
            />
          </div>
          {displayIcon === true ? (
            <div className="super-admin-filter-button">{filter}</div>
          ) : null}
        </div>
      </div>
    </React.Fragment>
  );
};
const offerTypes = [
  { id: 0, title: "All" },
  { id: 1, title: "Online" },
  { id: 2, title: "Offline" },
];

const statusCode = [
  { id: 0, title: "All" },
  { id: 1, title: "Active" },
  { id: 2, title: "Inactive" },
];

const sortByCode = [
  { id: 0, title: "Offer Name A-Z" },
  { id: 1, title: "Offer Name Z-A" },
];

const profileCompletion = [
  { id: 0, title: "1-25%" },
  { id: 1, title: "26-50%" },
  { id: 2, title: "51-75%" },
  { id: 3, title: "76-100%" },
];

const sortBy = [
  { id: 0, title: "name" },
  { id: 1, title: "Today" },
  { id: 2, title: "Last month" },
  { id: 3, title: "Last 3 months" },
];
